// import chroma from "chroma-js"
import { object } from "../helpers/object";
import { debug } from "../helpers/debug";

/*------------------------------------*\
  #BACKGROUND

  Class gestion des element [data-js-component="background"]
  - Création dynamique des lines opacity (effet visuel)
  - gestion texte contraste (blanc/fond foncé || noir fond clair)

  [data-js-component="background"]
  [data-js-background-color="{string}"] // couleur hexa de background
  [data-js-background-lines="{bool}"] // ajout des lignes en opacitées
  [data-js-background-position="{string}"] // position des lignes (top | right | bottom | left)
  [data-js-background-blur="{bool}"] // background avec un effet blur
  [data-js-background-text-contrast="{bool|string}"] // gestion de couleur de contraste du text (ex: fond foncé = text blanc) (true | false | auto)
\*------------------------------------*/
class Background {

  constructor(module){
    this.MODULE = module;
    this.DOM_MODULE = object.toArray(document.querySelectorAll(this.MODULE));
  }
  /**
   * INITIALISATION
   * @returns 
   */
  init = () => {
    if (!this.DOM_MODULE.length) return;
    this.DOM_MODULE.forEach((element) => {
      this.majDOM(element);
      if (element.matches('[data-js-background-text-contrast]')) {
        this.contrastInit(element);
      }
    });
    if(debug.DEBUG) console.log('async/background.js');
  }
  /**
   * MAJ DOM
   * 
   * Création des div c.background__***
   * utile pour la gestion du background
   * - multiply
   * - blur
   * - avec lines
   * 
   * @param {DOM} element 
   * @returns 
   */
  majDOM = (element) => {
    const firstChild = element.firstElementChild;
    const parent = element.closest('.c-section--banner, .c-push');
    if (!firstChild) return;

    firstChild.classList.add('c-background__top');
    
    // Creation element bg
    const bgColor = this.getBackgroundColor(element);
    const backgroundBottom = document.createElement('div');
    backgroundBottom.classList.add('c-background__bottom');
    backgroundBottom.style.setProperty('--background-color', `${bgColor}`);
    if (parent) parent.style.setProperty('--background-color', `${bgColor}`);

    const backgroundBg = document.createElement('div');
    backgroundBg.classList.add('c-background__bg');
    backgroundBottom.appendChild(backgroundBg);

    element.appendChild(backgroundBottom);
  }
  /**
   * GET BACKGROUND COLOR
   * 
   * Récupération de l'attribut background-color
   * @param {DOM} element 
   * @returns 
   */
  getBackgroundColor = (element) => {
    return element.getAttribute('data-js-background-color') ?? "#000";
  }
  /**
   * CONTRAST INIT
   * 
   * Permet l'ajout d'une class modifier 
   * ".c-background--contrasted" au component
   * .c-background pour passer les contenu text
   * en blanc/fond foncé
   * - gestion "auto" ou forcé "true"
   * @param {DOM} element 
   */
  contrastInit = (element) => {
    const contrastClass = 'c-background--contrasted';
    const dataAttr = element.getAttribute('data-js-background-text-contrast');

    if (dataAttr === 'true' || (dataAttr === 'auto' && this.getContrastRatio(this.getBackgroundColor(element)) < 5)) {
      element.classList.add(contrastClass);
    }
  };

  /**
   * GET CONTRAST RATIO
   * 
   * Calcule le ratio de contraste entre une couleur hexa et le blanc/noir
   * @param {string} hexColor 
   * @returns {number}
   */
  getContrastRatio = (hexColor) => {
    const luminance = (color) => {
      const a = color.map((v) => {
        v /= 255;
        return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
      });
      return a[0] * 0.2126 + a[1] * 0.7152 + a[2] * 0.0722;
    };

    const hexToRgb = (hex) => {
      let bigint = parseInt(hex.slice(1), 16);
      let r = (bigint >> 16) & 255;
      let g = (bigint >> 8) & 255;
      let b = bigint & 255;
      return [r, g, b];
    };

    const color = hexToRgb(hexColor);
    const white = [255, 255, 255];
    const black = [0, 0, 0];

    const luminanceColor = luminance(color);
    const luminanceWhite = luminance(white);
    const luminanceBlack = luminance(black);

    const contrastWhite = (luminanceColor + 0.05) / (luminanceWhite + 0.05);
    const contrastBlack = (luminanceColor + 0.05) / (luminanceBlack + 0.05);

    
    return Math.max(contrastWhite, contrastBlack);
  }
}
export default new Background('[data-js-component="background"]'); 
